export const Constants = {
  PAYSLIPS_DOCUMENTS_BUCKET:
    import.meta.env.VITE_NODE_ENV === 'production'
      ? import.meta.env.VITE_PROD_PAYSLIPS_DOCUMENTS_BUCKET
      : import.meta.env.VITE_DEV_PAYSLIPS_DOCUMENTS_BUCKET,
  LETTERS_DOCUMENTS_BUCKET:
    import.meta.env.VITE_NODE_ENV === 'production'
      ? import.meta.env.VITE_PROD_LETTERS_DOCUMENTS_BUCKET
      : import.meta.env.VITE_DEV_LETTERS_DOCUMENTS_BUCKET,
  NODE_ENV: import.meta.env.VITE_NODE_ENV,
  VITE_CKEDITOR_KEY: import.meta.env.VITE_CKEDITOR_KEY,
  SENTRY_AUTH_TOKEN: import.meta.env.VITE_SENTRY_AUTH_TOKEN,
}
